module.exports = __webpack_public_path__ + "j.no1.f07f526d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/j.no1.jpg
// module id = CbFV
// module chunks = 0